export default "__VITE_ASSET__3dd77b9c__"